/**
 * BubbleCha API client
 * BASE_URL 由 .env / .env.production 控制
 */

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Demo 展場統一使用 M001（林珍珠）
export const DEMO_MEMBER_ID = 'M001';

/** GET /api/member/{id} */
export async function getMember(memberId = DEMO_MEMBER_ID) {
  const res = await fetch(`${BASE_URL}/api/member/${memberId}`);
  if (!res.ok) throw new Error(`getMember HTTP ${res.status}`);
  return res.json();
}

/** POST /api/redeem */
export async function redeem(mode, memberId = DEMO_MEMBER_ID) {
  const res = await fetch(`${BASE_URL}/api/redeem`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mode, memberId }),
  });
  if (!res.ok) throw new Error(`redeem HTTP ${res.status}`);
  return res.json();
}

/** GET /api/barcode/{uuid}/status */
export async function getBarcodeStatus(uuid) {
  const res = await fetch(`${BASE_URL}/api/barcode/${uuid}/status`);
  if (!res.ok) throw new Error(`getBarcodeStatus HTTP ${res.status}`);
  return res.json();
}
